/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ShopBreadcrumbs_landingPage$ref = any;
export type LandingPageHeroItemLinkPosition = "center" | "left" | "right" | "%future added value";
export type ShopCarousel_landingPage$ref = any;
export type ShopCarousel_landingPage = {
    readonly hero: {
        readonly items: ReadonlyArray<{
            readonly imageUrl: string | null;
            readonly url: string | null;
            readonly linkPosition: LandingPageHeroItemLinkPosition | null;
            readonly title: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": ShopBreadcrumbs_landingPage$ref;
    readonly " $refType": ShopCarousel_landingPage$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShopCarousel_landingPage",
  "type": "LandingPage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "hero",
      "storageKey": null,
      "args": null,
      "concreteType": "LandingPageHero",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "LandingPageHeroItem",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "imageUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "linkPosition",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ShopBreadcrumbs_landingPage",
      "args": null
    }
  ]
};
(node as any).hash = '66776a40d2fb6dd270af7454f1c1c082';
export default node;
